const priceContracts: {cakeAddress: string, bnbAddress: string, lpAddress:string} = {
  cakeAddress: '0xdb48aea9cdf4bf01ff240973b345b16f39efacb4',
  bnbAddress: '0x4446Fc4eb47f2f6586f9fAAb68B3498F86C07521',
  lpAddress: '0x0c1AdeED89486a1eD631De0fa451a756f4458b82'
}

export default priceContracts